import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getNewCustomersAction = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_NEW_CUSTOMERS,
    payload: paramObj,
    meta: {
        type: 'api', //use apijson for returning json objects, and api for returning strings
        url: baseUrl + '/new_customers',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond
        },
        options: {
            method: 'GET'
        }
    }
})